module.exports = __webpack_public_path__ + "7ea4799706b2e97e1c08ce08c2c708cb.png";